import * as React from 'react';
import styled from 'styled-components';
import { IQuadrantResult } from '../../../data/providers/reports/quadrantReportProvider';
import { Entity } from '../../../data/types';
import { Row } from '../../layout/Row';
import { ListAvatar } from '../../shared/List/ListAvatar';
import { Metric } from '../../shared/Metric';
import { EPdfMode, isPdf, shouldInvert } from '../../shared/pdf/Pdf';
import { DataCell, DataColumn } from '../utils/Table';

interface IProps {
  result: IQuadrantResult;
  pdfMode: EPdfMode;
  entity: Entity;
  color: string;
  rank: number;
  shape: number[];
}

export const QuadrantResult = (props: IProps): React.ReactElement => {
  return (
    <Row
      className='avoid-break'
      style={{
        height: '100%',
      }}
    >
      <DataColumn style={{ flex: props.shape[0] }}>
        <DataCell>
          <Rank>{`${props.rank}.`}</Rank>
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[1], minWidth: 0 }}>
        <DataCell style={{ flex: 1, padding: '0px' }}>
          <ListAvatar
            entity={props.result.entity}
            inverse={shouldInvert(props.pdfMode)}
            pdf={isPdf(props.pdfMode)}
            style={{ padding: '10px' }}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[2] }}>
        <DataCell>
          <Metric
            style={{ alignItems: 'center' }}
            value={props.result.x.value}
            units={props.result.x.units}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[3] }}>
        <DataCell>
          <Metric
            style={{ alignItems: 'center' }}
            value={props.result.y.value}
            units={props.result.y.units}
          />
        </DataCell>
      </DataColumn>
      <DataColumn
        style={{ flex: props.shape[4], justifyContent: 'flex-start' }}
      >
        <DataCell lastInRow>
          <div>
            <div>{props.result.quadrantDefinition.label}</div>
            <div style={{ fontSize: '.8em' }}>
              {props.result.quadrantDefinition.xDescription}
            </div>
            <div style={{ fontSize: '.8em' }}>
              {props.result.quadrantDefinition.yDescription}
            </div>
          </div>
        </DataCell>
      </DataColumn>
    </Row>
  );
};

const Rank = styled.div`
  margin-right: 5px;
  font-size: 1.1em;
`;
